import _ from 'lodash';

/**
 * Appends newly received rows to an existing table dataset without duplicating entries. Deep clones the current data and pushes each new row whose key value is not already present, matching on id by default.
 *
 * @param data - Existing table rows.
 * @param newData - Rows to append.
 * @param key - Row property used as the identity, defaulting to id.
 * @returns The cloned dataset extended with the unseen rows.
 */
const appearDataTable = (data: any, newData: any, key = 'id') => {
  const clonedData = _.cloneDeep(data);
  _.forEach(newData, (x) => {
    if (!_.find(clonedData, (d) => d[key] === x[key])) {
      clonedData.push(x);
    }
  });
  return clonedData;
};

export { appearDataTable };
